import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ThinDropdownWithSearch } from "../../../common/GeneralComponent.jsx";
import PlannedFields from "./IAPS_components/PlannedFields";
import InProgressFields from "./IAPS_components/InProgressFields";
import CompletedFields from "./IAPS_components/CompletedFields";
import PostponedFields from "./IAPS_components/PostponedFields";
import CancelledFields from "./IAPS_components/CancelledFields.jsx";

const ImplementationAndPhysical = ({ data }) => {
  const dispatch = useDispatch();
  const authState = useSelector((state) => state.auth.user || {});
  const userPermissions = authState.user_permissions || [];
  const isDQA = userPermissions.includes("dqa-approve");
  const isPM = userPermissions.includes("pm-approve");
  const isSuperAdmin = isDQA && isPM;
  const implementationDetails = data?.implementationDetails || {};
  const [overallStatus, setOverallStatus] = useState(implementationDetails?.overall_status || "Planned");
  const [approvalStatus, setApprovalStatus] = useState(implementationDetails?.approvalStatus || null);
  const role_name = isDQA ? "DQA" : isPM ? "PM" : "User";

  const statusOptions = [
    { value: "Planned", label: "Planned" },
    { value: "In Progress", label: "In Progress" },
    { value: "Completed", label: "Completed" },
    { value: "Postponed", label: "Postponed" },
    { value: "Cancelled / Excluded", label: "Cancelled / Excluded" },
  ];

  const handleApprove = () => {
    alert(`Approved by ${role_name}`);
    setApprovalStatus("approved");
  };

  const handleReject = () => {
    alert(`Rejected by ${role_name}`);
    setApprovalStatus("rejected");
  };

  useEffect(() => {
    if (implementationDetails?.overall_status) {
      setOverallStatus(implementationDetails.overall_status);
    }
  }, [implementationDetails]);

  return (
    <div className="rounded p-4">
      <form className="w-full">
        {/* Overall Status */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
          <div className="w-full">
            <ThinDropdownWithSearch
              required={false}
              label="Overall Status"
              id="overallStatus"
              disabled
              options={statusOptions}
              value={overallStatus}
              onChange={(value) => setOverallStatus(value)}
            />
          </div>
          <div className="w-full"></div> {/* Balance */}
          <div className="w-full"></div> {/* Balance */}
        </div>
        {/* Conditional Rendering of Sections */}
        {overallStatus === "Planned" && <PlannedFields data={data} />}
        {overallStatus === "In Progress" && <InProgressFields data={data} />}
        {overallStatus === "Completed" && <CompletedFields data={data} />}
        {overallStatus === "Postponed" && <PostponedFields data={data} />}
        {overallStatus === "Cancelled / Excluded" && <CancelledFields data={data} />}
      </form>
    </div>
  );
};

export default ImplementationAndPhysical;